import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const arabicMessages = {
  'input.placeholder': 'مصطلح البحث الخاص بك / OnlineCode',
};

const englishMessages = {
  'input.placeholder': 'Your search term / OnlineCode',
};

const germanMessages = {
  'input.placeholder': 'Ihr Suchbegriff / Configurator OnlineCode',
};

const messages = {
  ar_XA: arabicMessages,
  ar_XD: arabicMessages,
  ar_XH: arabicMessages,
  ar_AE: arabicMessages,
  en_XA: englishMessages,
  en_XD: englishMessages,
  en_XH: englishMessages,
  de_AQ: germanMessages,
  de_DE: germanMessages,
  de_LU: germanMessages,
  en_AQ: englishMessages,
  en_GB: englishMessages,
  en_US: englishMessages,
  en_ZA: englishMessages,
  fr_BE: {
    'input.placeholder': 'Votre mot clé / code en ligne',
  },
  da_DK: {
    'input.placeholder': 'Din søgning / OnlineCode Configurator',
  },
  sv_SE: {
    'input.placeholder': 'Din sökterm / Onlinekod konfiguratorn',
  },
  fr_LU: {
    'input.placeholder': 'Votre mot clé / code en ligne',
  },
  hu_HU: {
    'input.placeholder': 'Keresett kifejezés / OnlineCode',
  },
  no_NO: {
    'input.placeholder': 'Ditt søkeord/Online-kode konfigurator',
  },
  nl_BE: {
    'input.placeholder': 'Uw zoekterm / Configurator OnlineCode',
  },
  nl_NL: {
    'input.placeholder': 'Uw zoekterm / Configurator OnlineCode',
  },
  pl_PL: {
    'input.placeholder': 'Wyszukiwane słowo / kod online',
  },
  pt_PT: {
    'input.placeholder': 'Termo de pesquisa / Configurador código online',
  },
  pt_BR: {
    'input.placeholder': 'Resultados da sua busca / Código Online do configurador',
  },
  es_ES: {
    'input.placeholder': 'Tu búsqueda / Código online del configurador',
  },
  en_AU: {
    'input.placeholder': 'Your search term / OnlineCode Configurator',
  },
  en_NZ: {
    'input.placeholder': 'Your search term / OnlineCode Configurator',
  },
  ro_RO: {
    'input.placeholder': 'Termenul dumneavoastră de căutare / Configurator OnlineCode',
  },
  it_IT: {
    'input.placeholder': 'La tua ricerca/ "OnlineCode Configurator"',
  },
  fr_FR: {
    'input.placeholder': 'Votre recherche/OnlineCode',
  },
  de_CH: germanMessages,
  fr_CH: {
    'input.placeholder': 'Votre terme de recherche / Configurateur OnlineCode',
  },
  it_CH: {
    'input.placeholder': 'Il vostro termine di ricerca / OnlineCode Configurator',
  },
  sk_SK: {
    'input.placeholder': 'Vami vyhľadávaný pojem / Online kód konfigurátora',
  },
  fr_CA: {
    'input.placeholder': 'Votre recherche/OnlineCode',
  },
  en_CA: englishMessages,
  en_ID: englishMessages,
  en_IN: englishMessages,
  en_MY: englishMessages,
  en_SG: englishMessages,
  en_TH: englishMessages,
  en_MT: englishMessages,
  th_TH: {
    'input.placeholder': 'ค้นหา',
  },
  en_IE: englishMessages,
  tr_TR: {
    'input.placeholder': 'Online kod ara / Web sitesinde ara',
  },
  hr_HR: {
    'input.placeholder': 'Vaš pojam za pretraživanje / Online kod za konfigurator',
  },
  et_EE: {
    'input.placeholder': 'Otsingusõna',
  },
  fi_FI: {
    'input.placeholder': 'Hakusanasi / Konfiguraattorin Online-koodi',
  },
  ru_RU: {
    'input.placeholder': 'Введите запрос / Код конфигурации',
  },
  ja_JP: {
    'input.placeholder': '検索',
  },
  es_AR: {
    'input.placeholder': 'Tu búsqueda / Código online del configurador',
  },
  lt_LT: {
    'input.placeholder': 'Jūsų paieškos terminas / OnlineCode Configurator',
  },
  uk_UA: {
    'input.placeholder': 'Ваш пошуковий запит / Конфігуратор OnlineCode',
  },
  cs_CZ: {
    'input.placeholder': 'Váš hledaný výraz / OnlineCode konfigurátoru',
  },
  en_EG: {
    'input.placeholder': 'Your search term / OnlineCode',
  },
  ar_EG: {},
  lv_LV: {
    'input.placeholder': 'Jūsu meklējums / OnlineCode konfigurators',
  },
  sl_SI: {
    'input.placeholder': 'Vaš iskalni pojem/konfigurator OnlineCode',
  },
  en_CY: {
    'input.placeholder': 'Your search term / OnlineCode',
  },
  is_IS: {
    'input.placeholder': 'Leitarorð þitt / OnlineCode stillingar',
  },
  hr_BA: {
    'input.placeholder': 'Vaš termin za pretragu / Konfigurator OnlineCode',
  },
  hr_RS: {
    'input.placeholder': 'Vaš termin za pretragu / Konfigurator OnlineCode',
  },
  en_VN: {
    'input.placeholder': 'Your search term / OnlineCode',
  },
  vi_VN: {
    'input.placeholder': 'Từ khóa tìm kiếm / OnlineCode từ công cụ chọn cấu hình xe',
  },
  zh_TW: {
    'input.placeholder': '請輸入關鍵字或訂製夢想車代碼',
  },
};

export default new VueI18n({
  locale: 'de_DE', // set locale
  fallbackLocale: 'en_GB', // set fallback locale
  messages, // set locale messages
});
